import { z } from "zod";
import { createEndpoint, createEndpointWithPagination, StandardSuccessResponseSchema } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    PartnerBadgeSchema,
    CreateBadgeRequestSchema,
    UpdateBadgeRequestSchema,
    SyncBadgesResponseSchema,
} from "../schemas/badge";

export interface AdminBadgeListQueryParams extends QueryParams {
    limit?: number;
    cursor?: string;
    status?: 'active' | 'inactive';
    tag?: string;
    search?: string;
}

export interface SyncBadgesToExpertBody {
    badge_ids: number[];
}

export function createAdminBadgesApi(http: HttpClient, baseUrl: string) {
    const adminBadgesBaseUrl = `${baseUrl}/admin/badges`;
    
    return {
        listBadges: createEndpointWithPagination<
            z.infer<typeof PartnerBadgeSchema>,
            unknown,
            unknown,
            AdminBadgeListQueryParams
        >(http, "GET", "", {
            base: adminBadgesBaseUrl,
            itemSchema: PartnerBadgeSchema,
        }),

        getBadge: createEndpoint<
            z.infer<typeof PartnerBadgeSchema>,
            unknown,
            QueryParams,
            { badge: number }
        >(http, "GET", "/:badge", {
            base: adminBadgesBaseUrl,
            responseSchema: PartnerBadgeSchema,
            params: ["badge"],
        }),

        createBadge: createEndpoint<
            z.infer<typeof PartnerBadgeSchema>,
            z.infer<typeof CreateBadgeRequestSchema>
        >(http, "POST", "", {
            base: adminBadgesBaseUrl,
            responseSchema: PartnerBadgeSchema,
        }),

        updateBadge: createEndpoint<
            z.infer<typeof PartnerBadgeSchema>,
            z.infer<typeof UpdateBadgeRequestSchema>,
            QueryParams,
            { badge: number }
        >(http, "PUT", "/:badge", {
            base: adminBadgesBaseUrl,
            responseSchema: PartnerBadgeSchema,
            params: ["badge"],
        }),

        deleteBadge: createEndpoint<
            z.infer<typeof StandardSuccessResponseSchema>,
            unknown,
            QueryParams,
            { badge: number }
        >(http, "DELETE", "/:badge", {
            base: adminBadgesBaseUrl,
            responseSchema: StandardSuccessResponseSchema,
            params: ["badge"],
        }),

        syncBadgesToExpert: createEndpoint<
            z.infer<typeof SyncBadgesResponseSchema>,
            SyncBadgesToExpertBody,
            QueryParams,
            { expertId: number }
        >(http, "POST", `${baseUrl}/admin/experts/:expertId/badges/sync`, {
            responseSchema: SyncBadgesResponseSchema,
            params: ["expertId"],
        }),
    };
}

